// Use to manually handle backspace key when editing a single feature
// and the trash is disabled.
export const handleBackspaceWhileEditing = (e, draw) => {
  const isLineString =
    draw.getSelected().features[0].geometry.type === 'LineString';

  e.preventDefault();
  if (e.key === 'Backspace') {
    // Minimum of 2 points for a line,
    // 4 for a polygon (the first and last points in a polygon are the same)
    const minimumPoints = isLineString ? 2 : 4;
    const { coordinates } = draw.getSelected().features[0].geometry;
    const currentLength = isLineString
      ? coordinates.length
      : coordinates[0].length;
    const selectedLength = draw.getSelectedPoints().features.length;
    if (currentLength - selectedLength >= minimumPoints) draw.trash();
  }
};

// Use to manually handle escape key when drawing or editing a feature
// Avoids existing features being deleted on escape
export const handleEscapeWhileDrawing = (e, setMapMode, mapMode) => {
  e.preventDefault();
  e.stopPropagation();
  if (e.key === 'Escape') {
    setMapMode(mapMode);
  }
};
